export class PageRequest{
    maxResultCount:number;
    skipCount:number;
    sorting:string;
    where:string;
}